import { render, staticRenderFns } from "./Negociacao.vue?vue&type=template&id=58be033a&scoped=true"
import script from "./Negociacao.vue?vue&type=script&lang=js"
export * from "./Negociacao.vue?vue&type=script&lang=js"
import style0 from "./Negociacao.vue?vue&type=style&index=0&id=58be033a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58be033a",
  null
  
)

export default component.exports